import { render, staticRenderFns } from "./my_works.vue?vue&type=template&id=584d8eb0&scoped=true&"
import script from "./my_works.vue?vue&type=script&lang=js&"
export * from "./my_works.vue?vue&type=script&lang=js&"
import style0 from "./my_works.vue?vue&type=style&index=0&id=584d8eb0&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "584d8eb0",
  null
  
)

export default component.exports